import React from 'react';
import {NgageSpinner} from "../NgageSpinner";

function BrandedLoader() {
  return (
    <div className="h-full flex items-center justify-center bg-gray-100">
        <NgageSpinner size={NgageSpinner.sizes.MEDIUM} />
    </div>
  );
}

export default BrandedLoader;